import { render } from "./Home.vue?vue&type=template&id=03dc9a1c&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=03dc9a1c&scoped=true&lang=css"

import exportComponent from "/Users/hk/Omat tiedostot/koodit/htmljacss/hkvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03dc9a1c"]])

export default __exports__